














import { LLayerGroup } from "vue2-leaflet";
import PointComponent from "./PointComponent.vue";
import { icon, LeafletMouseEvent } from "leaflet";
import bboxFilter from "@/utils/bbox_filter";
import Vue from "vue";
import Component from "vue-class-component";
import { features, maps } from "@/store";
import { IFixedPlatforms } from "@/store/features/models";
import { MutationTypes } from "@/store/mutations-types";

const platformIconUrl = require("../../../assets/icons/maps/fixed_platform.svg");

@Component({
  components: {
    LLayerGroup,
    PointComponent,
  },
})
export default class FixedPlatformsLayer extends Vue {
  //computed

  get iconGenerator() {
    return icon({
      iconUrl: platformIconUrl,
      iconSize: [40, 40],
    });
  }
  get filteredPlatforms() {
    return bboxFilter(this.fixedPlatforms, "geometry");
  }
  get fixedPlatforms() {
    return features.getters.fixedPlatforms;
  }
  get platformTagEnabled() {
    return features.getters.platformTagEnabled;
  }
  get selectedFixedPlatform() {
    return features.getters.selectedFixedPlatform;
  }
  get measurementActivated() {
    return maps.getters.measurementActivated;
  }
  get platformsTagsEnabledByZoom() {
    return maps.getters.platformsTagsEnabledByZoom;
  }

  //methods
  loadFeatures() {
    if (!this.fixedPlatforms.length) {
      features.dispatch("getFixedPlatforms");
    }
  }
  coords(platform: IFixedPlatforms) {
    let coordenadas = platform.geometry.coordinates;
    return [coordenadas[1], coordenadas[0]];
  }
  clickHandler(value: LeafletMouseEvent) {
    if (this.measurementActivated) {
      let coords = value.latlng;
      maps.commit(MutationTypes.ADD_MEASUREMENT_POINT, {
        tipo: "fixedPlatform",
        data: coords,
      });
    }
  }
  isSelected(platform: IFixedPlatforms) {
    return platform.id === this.selectedFixedPlatform;
  }

  created() {
    this.loadFeatures();
  }
}
